import { createSelector } from "@reduxjs/toolkit";
import { omit } from "ramda";

import { UIState } from "../../../../store/HOC/genericUI.slice";
import { RootState } from "../../../../store/rootReducer";

import { ComponentId } from "./enums";
import { PerpetratorFormDataInputs } from "./perpetrator.slice";

export const selectFormData = (store: RootState): PerpetratorFormDataInputs =>
  store.ocProperty.perpetrator.data;

const selectRegistrationNumber = createSelector(selectFormData, (data) => ({
  name: "Numer rejestracyjny pojazdu sprawcy",
  value: data[ComponentId.REGISTRATION_NUMBER],
}));

const selectOcNumber = createSelector(selectFormData, (data) => ({
  name: "Numer polisy",
  value: ["PL-OC", data[ComponentId.OC_NUMBER]].join(" "),
}));

export const selectSummaryData = createSelector(
  selectRegistrationNumber,
  selectOcNumber,
  (registrationNumber, ocNumber) => [registrationNumber, ocNumber]
);

export const selectFormDataWithoutRedirect = createSelector(
  selectFormData,
  (data) => omit(["redirect"], data)
);

export const selectUIData = (store: RootState): UIState =>
  store.ocProperty.perpetrator.ui;
